import React, { Component } from 'react';
import { serverIp, firebaseAuth, toCurrency, pythonApiIp, logComponentLoad } from '../../../../config/constants.js'
import { Form, Segment, Button } from 'semantic-ui-react';
import * as UiConsts from '../../../../config/UiConstants';
import axios from 'axios';
import { SingleDatePicker } from 'react-dates';
import AworiLogTransactions from './AworiLogTransactions.js';
//import { getPrintValues, getDesigners, checkAdminEmail } from '../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import { checkAdminEmail, getPrintValues } from '../../newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import Select from 'react-select';



class EnterAworiLogs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            depositAmount: 0,
            deductAmount: 0,
            newBalance: null,
            reason: '',
            dateString: '',
            fromWhere: '',
            fromWhereOptions: [],
            // fromWhereOptions: [
            //     {
            //         "category": "fromWhere",
            //         "label": "Single/ Many Projects",
            //         "value": "largeProject",
            //         "key": "largeProject"
            //     },
            //     {
            //         "category": "fromWhere",
            //         "label": "Many small Orders",
            //         "value": "normalOrders",
            //         "key": "normalOrders"
            //     },
            //     {
            //         "category": "fromWhere",
            //         "label": "stockPayment - deduct",
            //         "value": "stockPayment",
            //         "key": "stockPayment"
            //     },
            // ]
        }
    }


    componentDidMount() {
        console.log("entx8 +++++ componentDidMount - ");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");


            if (user) {


                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }


        })
    }

    fromWhere = (statuses) => {
        //  console.log("ddx12 ++++++ loadStatuses ");
        // console.log("ddx121 statuses:" + JSON.stringify(statuses, null, 3));
        this.setState({ fromWhereOptions: statuses })
    }

    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "EnterAworiLogs");

        getPrintValues("fromWhere", this.fromWhere);


        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    // ##########################::  FIRST :##########################:
    sendAworiLog = () => {
        console.log("entx1 +++++ sendAworiLog - ");

        //if (this.state.depositAmount.length < 4) {
        if (this.state.depositAmount == null && this.state.deductAmount == null) {
            alert("error, all values are null, must have atleast one argument");

        } else if (this.state.fromWhere == '') {
            alert("error, from where is null");
        }


        else {

            this.setState({ loading: true });
            console.log("entx122 checking order numbers");

            // let tempDeductAmount = 0;
            // if (this.state.deductAmount === "") {
            //     tempDeductAmount = null;
            // } else {
            //     tempDeductAmount = this.state.deductAmount;
            // }

            // let tempdepositAmount = 0;
            // if (this.state.depositAmount === "") {
            //     tempdepositAmount = 0;
            // } else {
            //     tempdepositAmount = this.state.depositAmount;
            // }

            // let tempnewBalance = 0;
            // if (this.state.newBalance === "") {
            //     tempnewBalance = 0;
            // } else {
            //     tempnewBalance = this.state.newBalance;
            // }

            // SEND CHECK TO SERVER
            //axios.post(pythonApiIp + 'enterAworiLog', {
            axios.post(serverIp + 'awori/saveAworiLog', {
                apiKey: "raw222",
                deductAmount: this.state.deductAmount,
                depositAmount: this.state.depositAmount,
                reason: this.state.reason,
                fromWhere: this.state.fromWhere,
                adminEmail: this.state.user.email,
                daDate: this.state.selectedDate,
                enteredBy: this.state.user.email
            })
                .then((response) => {
                    // console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                    // console.log("entx22 result:" + response.data.result);

                    // CHECK RECEIPTS
                    if (response.data.result) {

                        this.setState({ loading: false });
                        alert("Success:" + response.data.message);

                        this.clearFields();
                    } else if (!response.data.result) {
                        alert("Error:" + response.data.message);
                        this.setState({ loading: false });
                    }

                    

                })
                .catch((error) => {
                    console.log(error);
                    //this.setState({ loading: false })
                   // this.clearFields();
                });

        }
    }

    dateSelectOnChange = (date) => {
        console.log("+++++++:dateSelectOnChange");
        console.log("date sent:" + date)
        console.log("dateString:" + date.format('dddd MMMM Do'));
        this.setState({
            selectedDate: date.valueOf(),
            dateString: date.format('dddd MMMM Do')
        })

        console.log(date.valueOf());
    }

    clearFields = () => {

        this.setState({
            loading: false,
            depositAmount: 0,
            deductAmount: 0,
            reason: '',
            selectedDate: '',
            dateString: '',
            fromWhere: ''
        })
    }

    handleDropDownChanges = (value) => {
        console.log("docx19 handleDropDownChanges");
        console.log('docx191 You\'ve sss:', value);
        console.log("docx192 category alone:" + value.category);
        console.log('docx193 You\'ve selected:', value.value + " " + value.category);
        console.log("docx195 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }


    render() {

        const wholeUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("enterAworiLog")
            ? <div>

                <Form size='large' onSubmit={this.sendAworiLog}>
                    <Segment stacked>

                        <SingleDatePicker
                            date={this.state.date} // momentPropTypes.momentObj or null
                            //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                            onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                            isOutsideRange={() => false}
                        />
                        <h3>{this.state.dateString}</h3>

                        <label> FROM WHERE </label>
                        <Select
                            name="form-field-name"
                            value={this.state.fromWhere}
                            options={this.state.fromWhereOptions}
                            onChange={this.handleDropDownChanges}
                            searchable={false}
                            clearable={false}
                        />

                        {/* depositAmount*/}
                        <Form.Field>
                            <label>Deposit Amount</label>
                            <label>{toCurrency(this.state.depositAmount)}</label>
                            <Form.Input
                                fluid
                                name={'depositAmount'}
                                value={this.state.depositAmount}

                                icon='add user'
                                iconPosition='left'
                                placeholder='depositAmount'
                                // onFocus={props.amp_logFieldClick}
                                onChange={this.handleTextInputChange}
                                type='number' />
                        </Form.Field>

                        {/* depositAmount*/}
                        <Form.Field>
                            <label>Deduction Amount</label>
                            <label>{toCurrency(this.state.deductAmount)}</label>
                            <Form.Input
                                fluid
                                name={'deductAmount'}
                                value={this.state.deductAmount}
                                icon='add user'
                                iconPosition='left'
                                placeholder='deductAmount'
                                // onFocus={props.amp_logFieldClick}
                                onChange={this.handleTextInputChange}
                                type='number' />
                        </Form.Field>

                        {/* depositAmount*/}
                        {/* <Form.Field>
                            <label>newBalance</label>
                            <Form.Input
                                fluid
                                name={'newBalance'}
                                value={this.state.newBalance}
                                icon='add user'
                                iconPosition='left'
                                placeholder='newBalance'
                                // onFocus={props.amp_logFieldClick}
                                onChange={this.handleTextInputChange}
                                type='number' />
                        </Form.Field> */}


                        {/* depositAmount*/}
                        <Form.Field>
                            <label>reason</label>
                            <Form.Input
                                fluid
                                name={'reason'}
                                value={this.state.reason}
                                icon='add user'
                                iconPosition='left'
                                placeholder='reason'
                                onChange={this.handleTextInputChange}
                                type='text' />
                        </Form.Field>




                        <Button color='blue' fluid size='large'>SEND</Button>
                    </Segment>
                </Form>
                <AworiLogTransactions />

            </div>
            : <h2>YOU ARE NOT AN AUTHORIZED</h2>


        return (
            this.state.loading ? <UiConsts.LoadingComponent /> :
                <div>
                    <h1>ENTER ACC DEP / DEDUCTIONS</h1>
                    {wholeUI}
                </div>
        );
    }
}

export default EnterAworiLogs;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/AworiLog/EnterAworiLogs.js